import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { DateFilterState } from './types';

const initialState: DateFilterState = {
  dateStartPicker: localStorage.getItem('dateStart')
    ? new Date(`${localStorage.getItem('dateStart')}`)
    : null,
  dateEndPicker: localStorage.getItem('dateEnd')
    ? new Date(`${localStorage.getItem('dateEnd')}`)
    : null,

  dateStart: localStorage.getItem('dateStart') || '',
  dateEnd: localStorage.getItem('dateEnd') || '',
};

export const dateFilterSlice = createSlice({
  name: 'dateFilter',
  initialState,
  reducers: {
    setDateStart: (state, action: PayloadAction<string>) => {
      state.dateStart = action.payload;
      localStorage.setItem('dateStart', action.payload);
    },
    setDateEnd: (state, action: PayloadAction<string>) => {
      state.dateEnd = action.payload;
      localStorage.setItem('dateEnd', action.payload);
    },
    setDateStartPicker: (state, action: PayloadAction<any>) => {
      state.dateStartPicker = action.payload;
    },
    setDateEndPicker: (state, action: PayloadAction<any>) => {
      state.dateEndPicker = action.payload;
    },
    setResetDateFilter: (state) => {
      state.dateStart = '';
      state.dateEnd = '';
      state.dateStartPicker = null;
      state.dateEndPicker = null;
      localStorage.removeItem('dateStart');
      localStorage.removeItem('dateEnd');
    },
  },
});

export const {
  setDateStart,
  setDateEnd,
  setDateStartPicker,
  setDateEndPicker,
  setResetDateFilter,
} = dateFilterSlice.actions;

export default dateFilterSlice.reducer;
